import { paths } from '~/routes/paths';

export const HOST_API = <string>import.meta.env.VITE_HOST_API;

export const PATH_AFTER_LOGIN = paths.dashboard.root;
